import fs from "fs";
import path from "path";
import { EnvxSchema } from "../../src/types";
import { META_JSON_FILE_NAME } from "../constants";

/**
 * Reads `envx.meta.json` file and returns it as a typed EnvxSchema object.
 * @param filePath - Path to envx.meta.json (default: ./envx.meta.json)
 */
export function parseEnvxMetaFile(filePath?: string): EnvxSchema {
  const resolvedPath =
    filePath ?? path.join(process.cwd(), META_JSON_FILE_NAME);

  if (!fs.existsSync(resolvedPath)) {
    throw new Error(`Meta file not found at ${resolvedPath}`);
  }

  const raw = fs.readFileSync(resolvedPath, "utf-8");

  try {
    const parsed: EnvxSchema = JSON.parse(raw);
    return parsed;
  } catch (err) {
    throw new Error(
      `Invalid JSON in ${resolvedPath}: ${(err as Error).message}`
    );
  }
}
